var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color}},[_c('svg',{attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }